import React, { createContext, useContext, useState, useCallback } from 'react';

const ToastContext = createContext(null);

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) {
    throw new Error('useToast debe usarse dentro de ToastProvider');
  }
  return ctx;
}

export default function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  const showToast = useCallback((message, options = {}) => {
    const id = `${Date.now()}-${Math.random()}`;

    const toast = {
      id,
      message,
      type: options.type || 'default', // success | error | info
      duration: options.duration || 2600,
    };

    setToasts((prev) => [...prev, toast]);

    setTimeout(() => {
      removeToast(id);
    }, toast.duration);
  }, [removeToast]);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}

      <div
        style={{
          position: 'fixed',
          bottom: 24,
          left: 0,
          right: 0,
          display: 'flex',
          justifyContent: 'center',
          pointerEvents: 'none',
          zIndex: 9999,
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            alignItems: 'center',
          }}
        >
          {toasts.map((t) => (
            <div
              key={t.id}
              style={{
                minWidth: 220,
                maxWidth: 320,
                padding: '12px 16px',
                borderRadius: 16,
                backdropFilter: 'blur(18px)',
                WebkitBackdropFilter: 'blur(18px)',
                fontSize: 13.5,
                fontWeight: 700,
                letterSpacing: 0.2,
                color: '#FFF',
                textAlign: 'center',
                background:
                  t.type === 'success'
                    ? 'linear-gradient(135deg, rgba(34,197,94,0.85), rgba(22,163,74,0.85))'
                    : t.type === 'error'
                    ? 'linear-gradient(135deg, rgba(239,68,68,0.85), rgba(185,28,28,0.85))'
                    : 'linear-gradient(135deg, rgba(139,92,246,0.85), rgba(91,33,182,0.85))',
                border: '1px solid rgba(255,255,255,0.15)',
                boxShadow:
                  '0 12px 30px rgba(0,0,0,0.25), 0 0 24px rgba(139,92,246,0.25)',
                animation: 'toast-in 180ms ease',
                pointerEvents: 'auto',
              }}
            >
              {t.message}
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes toast-in {
          from {
            opacity: 0;
            transform: translateY(10px) scale(0.98);
          }
          to {
            opacity: 1;
            transform: translateY(0px) scale(1);
          }
        }
      `}</style>
    </ToastContext.Provider>
  );
}